import React from "react";
import Carousel from "../carousel";
import ItemList from "../itemList";
import ItemListBotella from "../itemListBotella";
import "./s.css";

const galeria = [
  { image: "/carousel/C.jpg", caption: "Cartel Limbo" },
  { image: "/carousel/yuyo.jpeg", caption: "Yuyos" },
  { image: "/carousel/B.jpg", caption: "Campo" },
  { image: "/carousel/otonio.jpg", caption: "Otoño" },
  { image: "/carousel/E.jpg", caption: "Invierno" },
  { image: "/carousel/F.jpg", caption: "Uvas desde adentro" },
  { image: "/carousel/G.jpg", caption: "Nieve" },
  { image: "/carousel/H.jpg", caption: "Cultivo" },
  { image: "/carousel/I.jpg", caption: "Finca" },
  { image: "/carousel/J.jpg", caption: "Uvas" },
];

const Home = ({ products, items }) => {
  return (
    <>
      <Carousel data={galeria} />
      <div className="contenedor-vinos">
        <div className="intro">
          <p>
            Nos concentramos en pequeñas producciones de vino de parcelas propias y únicas.
          </p>
        </div>
        <div className="contenedorVinos">
          <h2>Vinos criados en barrica</h2>
          {products.map((product) => (
            <ItemList key={product.Titulo} product={product} />
          ))}
        </div>
        <div className="contenedorVinos">
          <h2>Vinos criados en botella</h2>
          {items.map((item) => (
            <ItemListBotella key={item.Titulo} item={item} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Home;
